var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mds-header mds-header--level-3 mre-padding"},[_c('h2',{staticClass:"mds-header__title"},[_vm._v("Page not Found")])])])
}]

export { render, staticRenderFns }